import { Card, Modal, Radio } from "antd";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import tw from "tailwind-styled-components";
import {
	clearAttendance,
	CreateTimeSheet,
	loadSingleAttendance,
} from "../../redux/rtk/features/attendance/attendanceSlice";
import getUserFromToken from "../../utils/getUserFromToken";
import Loader from "../loader/loader";
import PageTitle from "../page-header/PageHeader";

const DetailAttendance = () => {
	const { id } = useParams("id");
	const approvedBy = getUserFromToken();
	const attendance = useSelector((state) => state.attendance.attendance);
	const dispatch = useDispatch();
	const [selectedStatus, setSelectedStatus] = useState(null);

	console.log("approvedBy",approvedBy);
	

	useEffect(() => {
		dispatch(loadSingleAttendance(id));

		return () => {
			dispatch(clearAttendance());
		};
	}, []);

	const handleStatusChange = (e) => {
		setSelectedStatus(e.target.value);
		Modal.confirm({
			title: `Confirm ${e.target.value === "approved" ? "Approval" : "Rejection"}`,
			content: `Are you sure you want to ${e.target.value} this attendance?`,
			okText: "Yes",
			cancelText: "No",
			onOk: async () => {
				try {
					const response = await dispatch(
						CreateTimeSheet({
							
							id,
							values: {
								approvedBy: approvedBy,
								status: e.target.value === "approved",
							},
						})
					);
					if (response.payload.message === "success") {
						toast.success(`Attendance ${e.target.value} successfully`);
					} else {
						throw new Error("Error updating attendance");
					}
				} catch (error) {
					toast.error(`Failed to ${e.target.value} attendance: ${error.message}`);
				}
			},
		});
	};
	

	return (
		<div>
			<PageTitle title='Back' />
			<Card className='mt-4'>
				<div className='text-center mb-4'>
					{" "}
					<h2 className='text-2xl font-semibold text-gray-600'>
						Attendance Status {" "}
					</h2>
				</div>
				{attendance ? (
					<div className='flex justify-center '>
						<ul className='list-inside list-none border-2 border-inherit rounded px-5 py-5 '>
							<ListItem>
								Name :{" "}
								<TextInside>
									{(
										attendance?.user.firstName +
										" " +
										attendance?.user.lastName
									).toUpperCase()}{" "}
								</TextInside>
							</ListItem>
							<ListItem>
								Work Start Time :{" "}
								<TextInside>
									{dayjs(attendance.inTime).utc().format("DD-MM-YYYY, h:mm A")}
								</TextInside>
							</ListItem>
							{/* <ListItem>
								Break Start Time :{" "}
								<TextInside>
									{dayjs(attendance.breakHourStart).utc().format("DD-MM-YYYY, h:mm A")}
								</TextInside>
							</ListItem>
							<ListItem>
								Break End Time :{" "}
								<TextInside>
									{dayjs(attendance.breakHourEnd).utc().format("DD-MM-YYYY, h:mm A")}
								</TextInside>
							</ListItem> */}
							<ListItem>
								Work End Time :{" "}
								<TextInside>
									{dayjs(attendance.outTime).utc().format("DD-MM-YYYY, h:mm A")}
								</TextInside>
							</ListItem>
							<ListItem>
								Total Hour :{" "}
								<TextInside>{attendance.totalHour || "No total hour"}</TextInside>
							</ListItem>
							<ListItem>
								Total Break Hours :{" "}
								<TextInside>{attendance.totalBreakHours || "No total break hours"}</TextInside>
							</ListItem>
							<ListItem>
								Punch By :{" "}
								<TextInside className='text-green-500'>
									{`${attendance.punchByUser.firstName} ${attendance.punchByUser.lastName} ` || "ON REVIEW"}
								</TextInside>
							</ListItem>

							<ListItem>
								Task :{" "}
								<TextInside>{attendance.comment || "No Task"}</TextInside>
							</ListItem>
							<div className="mt-4">
								Approve Status: {" "}
								<Radio.Group onChange={handleStatusChange} >
									<Radio.Button value="approved" className="mr-4">
										Approved
									</Radio.Button>
									<Radio.Button value="rejected">Reject</Radio.Button>
								</Radio.Group>
							</div>
						</ul>

					</div>
				) : (
					<Loader />
				)}
			</Card>
		</div>
	);

	// "reviewComment": null,
	// "attachment": null,
};

const ListItem = tw.li`
text-sm
text-gray-600
font-semibold
py-2
px-4
bg-gray-100
mb-1.5
rounded
w-96
flex
justify-start
`;

const TextInside = tw.p`
ml-2
text-sm
text-gray-900
`;
export default DetailAttendance;
